module.exports = __webpack_public_path__ + "static/img/ph02.b7abfb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/works/drawn/ph02.jpg
// module id = iEar
// module chunks = 0